import { useState, useEffect } from 'react';
import { getTranslation } from '../i18n/translations';

export const useTranslation = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [t, setT] = useState(getTranslation('en'));

  useEffect(() => {
    // Load language from localStorage
    const savedLang = localStorage.getItem('maisonEzeLanguage') || 'en';
    setCurrentLanguage(savedLang);
    setT(getTranslation(savedLang));

    // Listen for language changes
    const handleLanguageChange = () => {
      const lang = localStorage.getItem('maisonEzeLanguage') || 'en';
      setCurrentLanguage(lang);
      setT(getTranslation(lang));
    };

    window.addEventListener('languageChange', handleLanguageChange);
    
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  return { t, currentLanguage };
};
